import styled, { css } from 'styled-components';

export const ChoiceBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
`;

export const ChoiceCard = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  border: 1px solid #d3d3d3;
  border-radius: 12px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  width: 100%;

  &:hover {
    background: #f9f9f9;
  }

  &:focus-visible {
    outline: none;
    border-color: #be1622;
  }

  ${({ $selected }) =>
    $selected &&
    css`
      border-color: #be1622;
      background: #fff5f6;

      &:hover {
        background: #fff5f6;
      }
    `}
`;

export const ChoiceIcon = styled.div`
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;

  i {
    font-size: 28px;
    line-height: 1;
  }
`;

export const ChoiceInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ChoiceTitle = styled.span`
  font-size: 18px;
  font-weight: 500;
  color: #333;
`;

export const ChoiceDesc = styled.span`
  font-size: 14px;
  color: #666;
`;
